import { render, staticRenderFns } from "./RejectCandidateAction.vue?vue&type=template&id=6121c548&"
import script from "./RejectCandidateAction.vue?vue&type=script&lang=js&"
export * from "./RejectCandidateAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports